import { Stack, Tooltip, Typography } from '@mui/material';
import {
  type RestoreAccount,
  type SourceAccount,
  AccountState,
  type Account,
} from '@repo/api-gw-sdk';
import semver from 'semver';

import { getAccountState } from '@/utils/accounts';
import {
  getAccountInstalledVersion,
  isAccountRoleMajorMinorVersionOld,
} from '@/utils/roles';

import { Icon } from '../shared/icon';

export const EonRoleVersion = ({
  account,
}: {
  account: Account | SourceAccount | RestoreAccount;
}) => {
  const accountState = getAccountState(account);
  if (accountState === AccountState.ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS) {
    return <Typography>--</Typography>;
  }

  const showWarning = isAccountRoleMajorMinorVersionOld(account);
  const installedVersion = getAccountInstalledVersion(account);

  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <Typography className={'inline-block'}>
        {installedVersion && semver.valid(installedVersion)
          ? installedVersion
          : '1.0.0'}
      </Typography>
      {showWarning && (
        <Tooltip title='Update available'>
          <Icon
            iconClass={
              'material-symbols-error-outline-rounded h-[20px] w-[20px]'
            }
          />
        </Tooltip>
      )}
    </Stack>
  );
};
